<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer023">
<p class="dedication" lang="en-US"><span lang="en-US">“Feel the bile rising from your guilty past</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">With your nerves in tatters</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">As the cockleshell shatters</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">And the hammers batter down your door</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">You’d better run …”</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">—Roger Waters/Pink Floyd </span></p>
<p class="dedication" lang="en-US"><span lang="en-US"><i>Run Like Hell</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?1ddeeaa2